import { BASE_URL } from "../configs";

export async function verifyToken(token) {
    var headers = new Headers();
    headers.set("Accept", "application/json");
    headers.set("Content-Type", "application/json");

    let url = `${BASE_URL}/api/token-verify`;

    if (token) url += `?token=${token}`;

    const response = await fetch(url, {
        method: "get",
        headers,
        credentials: "include",
    });

    if (response.status > 400) {
        throw response;
    }

    const res = await response.json();
    return res.Data;
}

export async function getTokenWorklog(token) {
    var headers = new Headers();
    headers.set("Accept", "application/json");
    headers.set("Content-Type", "application/json");

    let url = `${BASE_URL}/api/token-worklog/${token}`;

    const response = await fetch(url, {
        method: "get",
        headers,
        credentials: "include",
    });

    if (response.status > 400) {
        throw response;
    }

    const res = await response.json();
    return res.Data;
}

export async function signDoc(token, data) {
    let url = `${BASE_URL}/api/sign-doc`;
    if (token) url += `?token=${token}`;

    const response = await fetch(url, {
        method: "post",
        body: data
    });

    if (response.status > 400) {
        throw response;
    }

    const res = await response.json();
    return res.Data;
}